import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Badge from 'atomic/badge';
import NumberOfOffer from 'atomic/number-of-offer';
import Price from 'atomic/price';
import Stars from 'atomic/stars';
import classNames from 'classnames';
import ProductListImpression from 'components/impressions/product-impression/list/product-list-impression';
import flectionNumeral from 'helpers/number';
import React, { useContext } from 'react';
import WidgetProductBoxItemInterface from './widget-product-box-item.props';
import AlertDiscountPriceInfo from 'modules/shared/components/alert-discount-price-info';
import { isMonoOffer } from 'helpers/offers-prepare';
import OfferLabel from 'modules/shared/modules/product/components/offer-label';
import { getMonoOfferLabel } from 'helpers/offer-label';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './widget-product-box-item.scss';

interface WidgetProductBoxItemProps {
    product: WidgetProductBoxItemInterface;
    loading?: 'lazy' | 'eager';
    className?: string;
}

const WidgetProductBoxItem: React.FC<WidgetProductBoxItemProps> = ({
    product,
    loading = 'lazy',
    className
}) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const offerLabel = getMonoOfferLabel(product);

    return (
        <ProductListImpression trackedData={{ ...product, price: product.minPrice }}
            className={classNames({
                'widget-product-box-container': true,
                [String(className)]: Boolean(className)
            })}
        >
            <a
                className="widget-product-box"
                href={isMonoOffer(product) ? product.offers.items[0].url : product.url}
                rel={isMonoOffer(product) ? SeoLinkRelEnum.NOOPENER_NOREFERRER : void 0}
                target={isMonoOffer(product) ? LinkTarget.BLANK : void 0}
            >
                {offerLabel && (
                    <div className="widget-product-box__label">
                        <OfferLabel label={offerLabel} />
                    </div>
                )}
                <div className="widget-product-box__photo-box">
                    <div className="widget-product-box__photo-box__image">
                        <img src={product.photo} alt={product.name} width={180}
                            loading={loading}
                        />
                    </div>
                    <div className="widget-product-box__photo-box__badges">
                        {product.discount > 0 && (
                            <Badge color="red">
                                <span>{product.discount}%</span>
                            </Badge>
                        )}
                    </div>
                </div>
                <div className="widget-product-box__title">
                    <h3>
                        {product.name}
                    </h3>
                </div>
                <div className="widget-product-box__stars">
                    <Stars width={product.opinions.average} size="md" />
                </div>
                <div className="widget-product-box__rating">
                    {product.opinions.average > 0 && (
                        <span>
                            {product.opinions.average.toFixed(1).replace('.', ',')}
                        </span>
                    )}
                    <span>
                        {product.opinions.count !== 0 ? `(${flectionNumeral(product.opinions.count, ['opinia', 'opinie', 'opinii'])})` : 'Brak opinii'}
                    </span>
                </div>
                <div className="widget-product-box__price">
                    <Price price={product.minPrice} weight={600} />
                    {product.discount > 0 && (
                        <Price
                            className="discount"
                            price={product.minPrice + (product.minPrice * (Math.abs(product.discount) / (100 - Math.abs(product.discount))))}
                            crossed={true}
                            color="red"
                            weight={500}
                        />
                    )}
                </div>
                {product.discount > 0 && (
                    <div className="product-box-lifestyle-mobile__discount-info">
                        <AlertDiscountPriceInfo paddingTop={0} paddingBottom={6} />
                    </div>
                )}
                <div className="widget-product-box__number-of-offer">
                    <NumberOfOffer offers={product.offers} />
                </div>
            </a>
        </ProductListImpression>
    );
};

export default WidgetProductBoxItem;
